export const DOC_TYPES = {
    RESUME: 'resume',
    REPORTS: 'report',
    SERTIFICATES: 'certificate',
    TEST_RESULTS: 'test_result',
    NOTES: 'eval_result',
    INTERVIEW: 'interview',
    OTHER: 'other',
};
export const DOC_TYPES_TITLES = {
    RESUME: 'Резюме',
    REPORTS: 'Отчеты',
    SERTIFICATES: 'Сертификаты по учебе',
    TEST_RESULTS: 'Результаты по пройденным тестам',
    NOTES: 'Результаты оценки (KPI, OKR и т.д.)',
    INTERVIEW: 'Транскрибация записи видео или аудио интервью',
    OTHER: 'Другое',
};

export const DOC_SOURCES = {
    LOADED_BY_USER: 'loaded',
    OTHER: 'other',
};
export const DOC_SOURCES_TITLES = {
    LOADED_BY_USER: 'Загружено с компьютера',
    OTHER: 'Другое',
};
